import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/foam-roof.html")({
  beforeLoad: () => { throw redirect({ to: "/foam-roofing", statusCode: 301 }); },
});
